import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {

	rootContainer: {
		display        : "flex",
		alignItems     : "center",
		justifyContent : "space-between",
		paddingBottom  : "1rem"
	},
	buttonStyles: {
		background : `${ theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack1 : theme.other.paletteNew.secondaryLightGrey }!important`,
		fontWeight : "500 !important"
	},
	gameImage: {
		height       : "18px",
		width        : "18px",
		borderRadius : "5px"
	},
	svgIcon: {
		width  : "2.3rem",
		height : "2.3rem"
	},
	statsContainer: {
		display: "flex"
	},
	shareBtn: {
		paddingInline : "1rem",
		":hover"      : {
			background: "none"
		}
	},
	shareBtnContainer: {
		display       : "flex",
		flexDirection : "row",
		alignItems    : "center",
		cursor        : "pointer",
		marginLeft    : "auto",
		marginRight   : "2rem"
	},
	shareBtnLastContainer: {
		display       : "flex",
		flexDirection : "row",
		alignItems    : "center",
		cursor        : "pointer",
		marginLeft    : "auto"
	},
	statsText: {
		paddingLeft : "0.5rem",
		color       : theme.other.colors.text.primary
	},
	proButtonChip: {
		padding  : "0.1rem !important",
		overflow : "hidden",
		position : "relative",
		":after" : {
			content         : "' '",
			position        : "absolute",
			left            : "50%",
			top             : "50%",
			height          : "140px",
			width           : "140px",
			backgroundImage : theme.other.paletteNew.proChipGradient,
			zIndex          : "0",
			transform       : "translate(-50%, -50%)",
			animation       : "rotateProChip 3s linear infinite",

			"@keyframes rotateProChip": {
				"0%": {
					transform: "translate(-50%, -50%) rotate(0deg)"
				},
				"100%": {
					transform: "translate(-50%, -50%) rotate(360deg)"
				}
			}
		}
	},
	proChipContentStyles: {
		position     : "relative",
		zIndex       : "1",
		background   : `${ theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack1 : theme.other.paletteNew.secondaryLightGrey }!important`,
		padding      : "0 1.5rem",
		borderRadius : "1rem"
	}
} ) );

